var map = {
	"./decidim/avatar-multiuser.png": 50250,
	"./decidim/brands/facebook.svg": 77004,
	"./decidim/brands/google.svg": 15077,
	"./decidim/brands/twitter-x.svg": 58694,
	"./decidim/cc-badge.png": 57044,
	"./decidim/decidim-logo.svg": 67896,
	"./decidim/default-avatar.svg": 37760,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 86876,
	"./decidim/icons.svg": 85851,
	"./decidim/pattern.png": 68796,
	"./decidim/placeholder-card-g.svg": 23161,
	"./decidim/placeholder-card-l.svg": 18706,
	"./decidim/placeholder.jpg": 70321,
	"./decidim/remixicon.symbol.svg": 89013,
	"./decidim/vendor/social-share-button/douban.svg": 14884,
	"./decidim/vendor/social-share-button/email.svg": 75073,
	"./decidim/vendor/social-share-button/facebook.svg": 73639,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 56505,
	"./decidim/vendor/social-share-button/hacker_news.svg": 69361,
	"./decidim/vendor/social-share-button/linkedin.svg": 79201,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 61346,
	"./decidim/vendor/social-share-button/pinterest.svg": 727,
	"./decidim/vendor/social-share-button/reddit.svg": 89531,
	"./decidim/vendor/social-share-button/telegram.svg": 21790,
	"./decidim/vendor/social-share-button/tumblr.svg": 47581,
	"./decidim/vendor/social-share-button/twitter.svg": 22160,
	"./decidim/vendor/social-share-button/vkontakte.svg": 56254,
	"./decidim/vendor/social-share-button/wechat.svg": 40377,
	"./decidim/vendor/social-share-button/whatsapp.svg": 23361,
	"./decidim/vendor/social-share-button/x.svg": 39977,
	"./decidim/vendor/social-share-button/xing.svg": 13255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42957;